import styled from '@emotion/styled';
import { gettext } from '@eventbrite/i18n';
import { LoadingButton } from '@eventbrite/marmalade';
import React from 'react';

export enum CreateAccountActionBarTestIds {
    Create = 'CreateAccountActionBarCreate',
    Login = 'CreateAccountActionBarLogin',
    Container = 'CreateAccountActionBarContainer',
}

export const CreateAccountActionBar = ({
    isSubmitting,
    isSubmitButtonDisabled,
}: {
    isSubmitButtonDisabled?: boolean;
    isSubmitting: boolean;
}) => {
    return (
        <Container data-testid={CreateAccountActionBarTestIds.Container}>
            <div>
                <LoadingButton
                    disabled={isSubmitting || isSubmitButtonDisabled}
                    isLoading={isSubmitting}
                    data-heap-id="create-account-logged-out-auto-create-event"
                    data-testid={CreateAccountActionBarTestIds.Create}
                    variant={'primary'}
                    size="block"
                    type={'submit'}
                >
                    {gettext('Create account')}
                </LoadingButton>
            </div>
        </Container>
    );
};

const Container = styled.div`
    margin: 24px 0;
`;
